import { ProductsAsVariantsConfigurationSchema } from "@redotech/redo-product-common/products-as-variants/products-as-variants-configuration";
import * as z from "zod";

export const testProductsAsVariantsConfigurations = {
  name: "testProductsAsVariantsConfigurations" as const,
  input: z.object({
    configurationsToTest: z.array(ProductsAsVariantsConfigurationSchema),
  }),
  output: z.object({
    success: z.boolean(),
    error: z.string().optional(),
    allResults: z.array(
      z.object({
        collectionId: z.string(),
        results: z.array(
          z.object({
            productTitle: z.string(),
            metafieldValue: z.string().optional(),
          }),
        ),
      }),
    ),
  }),
};
